window.addEventListener("load", function () {
    const heightWindow = $(window).height();
    const heightFloatLeft = $("#libraryMainsite-t-float_left").height();
    const top = heightWindow - heightFloatLeft - 20;
    $("#libraryMainsite-t-float_left").css("top", `${top}px`);
   
});
